import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { StickyConsultationBar } from '@/components/StickyConsultationBar';
import { GoldenParticles } from '@/components/effects/GoldenParticles';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-x-clip">
      {/* Sparkling orb particles across all pages */}
      <GoldenParticles count={40} className="!fixed z-[1] opacity-60" />

      {/* Soft luminous orb overlay */}
      <div className="fixed inset-0 z-[0] pointer-events-none" aria-hidden="true" style={{
        background: `
          radial-gradient(ellipse 50% 35% at 15% 20%, hsl(270 40% 45% / 0.09), transparent),
          radial-gradient(ellipse 45% 40% at 85% 75%, hsl(42 70% 55% / 0.07), transparent),
          radial-gradient(ellipse 60% 25% at 50% 50%, hsl(220 35% 45% / 0.06), transparent)
        `
      }} />

      <Header />
      <main id="main-content" className="flex-1 pt-20 relative z-[2] overflow-x-clip">{children}</main>
      <Footer />
      <StickyConsultationBar />
    </div>
  );
}
